import { Button } from "@/components/ui/button"
import { Text } from "@/components/ui/text"
import { Check, Circle, Square, X } from "lucide-solid"
import { Box } from "styled-system/jsx"

interface QuizOptionProps {
  option: string
  isMulti: boolean
  isReview: boolean
  isSelectedActive: boolean
  isSelectedReview: boolean
  isActuallyCorrect: boolean
  onToggle: () => void
}

export default function QuizOption(props: QuizOptionProps) {
  // 1. Color Palette: Jade/Red for review choices, Jade for active selection
  const colorPalette = () => {
    if (props.isReview && props.isSelectedReview) {
      return props.isActuallyCorrect ? "jade" : "red"
    }
    if (!props.isReview && props.isSelectedActive) {
      return "jade"
    }
    return "neutral"
  }

  // 2. Variant: Solid for reviewed choices, Outline for active selection
  const variant = () => {
    if (props.isReview && props.isSelectedReview) {
      return "solid"
    }
    if (!props.isReview && props.isSelectedActive) {
      return "outline"
    }
    return "subtle"
  }

  // 3. Icons: Check/X for reviewed choices, Check for active selection
  const OptionIcon = () => {
    if (props.isReview && props.isSelectedReview) {
      return props.isActuallyCorrect ? <Check /> : <X />
    }
    if (!props.isReview && props.isSelectedActive) {
      return <Check />
    }
    return props.isMulti ? <Square /> : <Circle />
  }

  return (
    <Box>
      <Button
        colorPalette={colorPalette()}
        variant={variant()}
        w="full"
        h="auto"
        p={4}
        justifyContent="flex-start"
        cursor={props.isReview ? "default" : "pointer"}
        onClick={() => !props.isReview && props.onToggle()}
        alignItems="center"
        gap={3}
        transition="all 0.2s"
      >
        <Box w="4" h="4" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
          {OptionIcon()}
        </Box>

        <Text textAlign="left" whiteSpace="normal">
          {props.option}
        </Text>
      </Button>
    </Box>
  )
}
